// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconDeviceAnalytics } from '@tabler/icons';

// constant
const icons = {
    IconDeviceAnalytics
};

// ==============================|| ENGAGEMENT MENU ITEMS ||============================== //

const engagement = {
    id: 'engagement',
    type: 'group',
    children: [
        {
            id: 'engagement-metrics',
            title: <FormattedMessage id="engagement" />,
            type: 'item',
            icon: icons.IconDeviceAnalytics,
            url: '/engagement'
        }
    ]
};

export default engagement;
